import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { graphContainer } from './graphContainers';
import GenericCategoryGraph, { chartTypeEnum } from '../../../components/Graphs/GenericCategoryGraph';
import { ColorPalette } from '../DashboardColorPalettes';
import { actions } from '../../SuperUser/Report/redux/actions';
import Strings from '../../../Strings';

function ConditionsDistribution(props) {
  const [data, setData] = React.useState();
  const { colorPalette, graphType, orgIds, refreshTimestamp, getPatientsStatistics } = props;

  React.useEffect(() => {
    // Use cached dispatch to avoid duplicate API calls
    import('../../../utils/apiCache').then(({ cachedDispatch }) => {
      cachedDispatch(
        'patients_statistics',
        { orgId: orgIds && orgIds.length > 0 ? orgIds : undefined },
        () => getPatientsStatistics({ orgId: orgIds && orgIds.length > 0 ? orgIds : undefined }),
        60000, // Cache for 1 minute
      ).then(response => {
        if (!response?.response?.conditions_by_title) {
          return;
        }
        const conditions = Object.entries(response.response.conditions_by_title).map(([title, count]) => ({
          name: title,
          count,
        }));
        const conditionsSorted = conditions.sort((a, b) => b.count - a.count);
        setData(
          conditionsSorted
            .slice(0, 10)
            .concat({ name: 'Other', count: conditionsSorted.slice(10).reduce((acc, c) => acc + c.count, 0) }),
        );
      });
    });
  }, [refreshTimestamp, orgIds]);

  const dataSeries = [
    {
      name: 'Condition',
      color: colorPalette?.interpolate(0.5),
      selector: item => item.count,
    },
  ];

  return graphContainer(
    <GenericCategoryGraph
      graphData={data}
      hasBorder
      forceCondensed
      xAxisTopPosition={false}
      yAxisWidth={graphType === chartTypeEnum.horizontalBar ? 200 : 40}
      yAxisAlign="end"
      yAxisUnit=""
      tooltipTitle={Strings.condition}
      dataSeries={dataSeries}
      categorySelector={item => item.name}
      hasReferenceAreas
      graphType={graphType}
      colorPalette={colorPalette}
    />,
    'Conditions Distribution',
  );
}

ConditionsDistribution.widgetId = 'ConditionsDistributionWidget';

ConditionsDistribution.propTypes = {
  getProgramStatistics: PropTypes.func,
  onClick: PropTypes.func,
  colorPalette: PropTypes.object,
  graphType: PropTypes.string,
  refreshTimestamp: PropTypes.number,
  orgIds: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = state => {
  return {
    colorPalette:
      ColorPalette[state.dashboardState.configuration?.allDashboards?.colorPalette] || Object.values(ColorPalette)[0],
    orgIds: state.entities?.orgFilter?.orgIds,
  };
};

const mapDispatchToProps = dispatch => ({
  getPatientsStatistics: pageRequest => dispatch(actions.getPatientsStatistics(pageRequest)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConditionsDistribution);
